import React from "react";
import { Button, Card, Col, Container, Nav, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

// Components
import { DeliveryMap } from "../Components/Home/DeliveryMap";
// Store
import { pathTitles, useStore } from "../Store/Store";

export const PuppyDelivery = () => {
  const getLink = useStore((state) => state.getLink);

  const services = [
    {
      cardHeaderTitle: "Puppy Delivery and New Owner Training",
      image: "youChooseAPuppy",
      cardBody: [
        <Card.Body key={Math.random()} className="services_offered card_body">
          We personally deliver your dog to your home. Our success is insured
          through the delivery and training with you, the new owner.
          <br />
          <br />
          Teaching you exactly what your puppy has learned and how to maintain
          their current behavior is just as important as your puppy’s education.
          Each puppy includes 6 lessons for their new owners with trainer
          Justine Ramey to learn exactly how to continue successfully with their
          new best friend.
        </Card.Body>,
      ],
    },
    {
      cardHeaderTitle: "Delivery",
      image: "beginsWithAConsult",
      cardBody: [
        <Card.Body key={Math.random()} className="services_offered card_body">
          During lessons we will cover all of the essential knowledge you need
          to know for a happy lifetime with your perfect family companion.
          <br />
          <br />
          <Card.Title>Within 2 hour of Indianapolis :</Card.Title>
          <br />
          <br />
          If you live within a few hours of Indy we arrange to do lessons while
          your puppy is getting its education. If you’re in the Indianapolis
          Metro area you can even take your puppy home on the weekend in the
          last 2 weeks of training. When your puppy is ready to go home (based
          on their potty training) you will have completed enough lessons to
          have you prepared for the big day. Now the puppy stays home and you
          use what you learned to have the best life with your new friend
          possible!
          <br />
          <br />
          <Card.Title>Out of State :</Card.Title>
          <br />
          <br />
          If you’re far away from Indy don’t worry! Trainer Justine Ramey has
          hand delivered trained puppies across the country. If you’re too far
          away from Indianapolis to do lessons while your puppy is being
          educated we do one zoom lesson during puppy’s training and then
          arrange a weekend (3 days) to deliver your puppy at the end of 8 weeks
          of training. Justine will fly or drive your puppy out personally. On
          day one Justine will spend the morning educating you on livability
          factors; crate training, potty training, how to set boundaries. Puppy
          spends the afternoon and evening with you. Day Two Justine will come
          back in the morning to discuss how your evening went and cover more
          advanced material including obedience. You will spend the afternoon
          with your puppy working on what was discussed in the past two days. On
          day three Justine will spend the morning with you one last time to
          cover any loose ends and questions. Now the puppy stays home and you
          use what you learned to have the best life with your new friend
          possible!
          <br />
          <br />
          Cost for delivery: dependent upon your location.
          <ol type="i">
            <li>
              Flat fee for gas + 2 nights in a nearby hotel (within 6-8 hours of
              Indy)
            </li>
            <li>Cost of Flight + 2 nights in a nearby hotel</li>
          </ol>
        </Card.Body>,
      ],
    },
    {
      cardHeaderTitle: "After Delivery",
      image: "findingTheBestBreed",
      cardBody: [
        <Card.Body key={Math.random()} className="services_offered card_body">
          After Delivery we are always here to assist you. Please contact us the
          moment you need help, have questions or concerns.
          <br />
          <br />
          And we always love to get updates!
        </Card.Body>,
      ],
    },
    {
      cardHeaderTitle: "Also included with Each Puppy",
      cardButtonPath: getLink(pathTitles.VIEWPUPPIES),
      cardButtonMsg: "View Puppies...",
      image: "goHomePackage",
      cardBody: [
        <Card.Body key={Math.random()} className="services_offered card_body">
          <ul>
            <li>
              6 Lessons for owners with Trainer Justine Ramey (Indy’s In Home
              Dog Trainer)
            </li>
            <li>Size appropriate crate</li>
            <li>Medium sized bag of size appropriate puppy food</li>
            <li>Rabies, Bordetella, DHPP</li>
            <li>Place mat/cot</li>
            <li>Homework Handouts</li>
            <li>Other essentials that we think you may need</li>
          </ul>
        </Card.Body>,
      ],
    },
  ];
  // City data for service areas
  const cities = [
    { name: "Indianapolis Metro Area", state: "IN", url: null },
    { name: "Greenville", state: "SC", url: "/greenville" },
    { name: "Columbia", state: "SC", url: "/columbia" },
    { name: "Champaign-Urbana", state: "IL", url: "/champaign-urbana" },
    { name: "Chicago", state: "IL", url: "/chicago" },
    { name: "Minneapolis", state: "MN", url: "/minneapolis" },
    { name: "New York", state: "NY", url: "/new-york" },
    { name: "Boston", state: "MA", url: "/boston" },
    { name: "San Francisco Bay Area", state: "CA", url: "/san-francisco" },
    { name: "Seattle", state: "WA", url: "/seattle" },
    { name: "Denver", state: "CO", url: "/denver" },
    { name: "Nashville", state: "TN", url: "/nashville" },
    { name: "Columbus", state: "OH", url: "/columbus" },
    { name: "Charlotte", state: "NC", url: "/charlotte" },
    { name: "Austin", state: "TX", url: "/austin" },
  ];

  return (
    <>
      <Container className="home_services_offered_container small_container clear">
        <Row className="justify-content-center first_row">
          {services.map((service, i) => (
            <React.Fragment key={`card${i}`}>
              <span
                className={`home_services_offered_image ${service.image}`}
              />
              <Card className="services_offered card_inner">
                <Card.Body className="parent_body">
                  <Card.Header className={`services_offered card_header`}>
                    {service.cardHeaderTitle}
                  </Card.Header>
                  {service.cardBody.map((body) => body)}
                  {service.cardButtonPath && (
                    <Button
                      className="services_offered card_button cedar"
                      as={Nav.Link}
                      href={service.cardButtonPath}
                    >
                      {service.cardButtonMsg}
                      {/* <ArrowRight style={{width: "50px"}} /> */}
                    </Button>
                  )}
                </Card.Body>
              </Card>
            </React.Fragment>
          ))}
        </Row>
      </Container>

      {/* Delivery Map */}
      <DeliveryMap />

      {/* Service Areas Section */}
      <Container
        style={{
          backgroundColor: "var(--bg-off-light)",
          padding: "60px 20px",
          marginTop: "40px",
        }}
        fluid
      >
        <Container>
          <Row>
            <Col>
              <h2
                style={{
                  textAlign: "center",
                  fontSize: "2.5rem",
                  fontWeight: "bold",
                  color: "var(--sea-green-dark)",
                  marginBottom: "1rem",
                }}
              >
                Our Service Areas
              </h2>
              <p
                style={{
                  textAlign: "center",
                  fontSize: "1.2rem",
                  color: "var(--text-color-light)",
                  maxWidth: "800px",
                  margin: "0 auto 3rem",
                }}
              >
                We deliver professionally trained puppies to families across the
                United States. Click on your city to learn more about delivery
                options in your area.
              </p>

              <Row>
                {cities.map((city, index) =>
                  city.url ? (
                    <Col key={index} md={4} sm={6} className="mb-3">
                      <Link
                        to={city.url}
                        style={{
                          textDecoration: "none",
                          color: "var(--text-color-light)",
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          padding: "12px 16px",
                          backgroundColor: "white",
                          borderRadius: "8px",
                          transition: "all 0.3s ease",
                          border: "1px solid #e0e0e0",
                        }}
                        className="service-area-link"
                      >
                        <span
                          style={{
                            width: "10px",
                            height: "10px",
                            borderRadius: "50%",
                            backgroundColor: "#c16552",
                            display: "inline-block",
                            flexShrink: 0,
                          }}
                        />
                        <span style={{ fontSize: "1.05rem" }}>
                          {city.name}, {city.state}
                        </span>
                      </Link>
                    </Col>
                  ) : (
                    <Col key={index} md={4} sm={6} className="mb-3">
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          padding: "12px 16px",
                          backgroundColor: "white",
                          borderRadius: "8px",
                          border: "1px solid #e0e0e0",
                        }}
                      >
                        <span
                          style={{
                            width: "10px",
                            height: "10px",
                            borderRadius: "50%",
                            backgroundColor: "#c16552",
                            display: "inline-block",
                            flexShrink: 0,
                          }}
                        />
                        <span
                          style={{
                            fontSize: "1.05rem",
                            color: "var(--text-color-light)",
                          }}
                        >
                          {city.name}, {city.state}
                        </span>
                      </div>
                    </Col>
                  ),
                )}
              </Row>
            </Col>
          </Row>
        </Container>
      </Container>

      <style>{`
        .service-area-link:hover {
          transform: translateX(5px);
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
          border-color: #c16552 !important;
        }
        .service-area-link:hover span:last-child {
          color: #c16552 !important;
        }
      `}</style>
    </>
  );
};
